module.exports = __webpack_public_path__ + "img/Icon_Closed_case.8e22db6e.svg";